export default __webpack_public_path__ + "static/media/Logo.0e3a5b26.png";